import MuiChip from '@mui/material/Chip';
import type { ReactElement } from 'react';

import { useColors } from '../ThemeProvider';

interface Props {
  label: string;
  icon?: ReactElement;
  fontSize?: '0.875rem' | '1rem';
  backgroundColor?: string;
  borderColor?: string;
  textColor?: string;
}

export function Chip({
  label,
  icon,
  fontSize = '1rem',
  backgroundColor,
  borderColor,
  textColor,
}: Props) {
  const { surface, border, textPrimary } = useColors();

  return (
    <MuiChip
      label={label}
      icon={icon}
      sx={{
        width: 'fit-content',
        height: 'auto',
        px: '.1rem',
        py: '.1rem',
        backgroundColor: backgroundColor ?? surface,
        fontSize,
        borderRadius: '6.25rem',
        border: `1px solid ${borderColor ?? border}`,
        color: textColor ?? textPrimary,
      }}
    />
  );
}
